import useCollection from 'hooks/useCollection'
import { useMemo } from 'react'

const collection = 'roles'

const useGetRoles = (props) => {
  const query = useMemo(() => ({ ref: collection, ...props }), [props])
  const [value, loading, error, next, loadingMore, loadMoreAvailable] =
    useCollection(query)

  return [value, loading, error, next, loadingMore, loadMoreAvailable]
}

export default useGetRoles
